export const DEFAULT_BILLING_CYCLE = 'annual' as const;

export type BillingCycle = 'monthly' | 'annual';

/**
 * Workspaces that can still take Starter's $20 first month (monthly billing
 * only) open on Monthly so the first price they see is the offer. Everyone
 * else, and anonymous marketing pages, keep the Annual default.
 */
export function resolveDefaultBillingCycle(args: {
  introEligible: boolean | undefined;
}): BillingCycle {
  return args.introEligible ? 'monthly' : DEFAULT_BILLING_CYCLE;
}
